import {
  Box,
  BoxProps,
  LinearProgress,
  Modal,
  ModalProps,
  Stack,
  Typography,
} from "@mui/material";
import { ReactElement, ReactNode, forwardRef, useEffect } from "react";
import { useMediaQuery } from "../CustomHook/useMediaQuery";
import "./CModal.scss";
// ----------------------------------------------------------------------
const DesktopStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: 24,
  width: "60vw",
  p: 4,
  zIndex: 99999999,
};

const MobileStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  borderRadius: "0px",
  boxShadow: 24,
  px: 2,
  pt: 6,
  overflow: "auto",
  zIndex: 99999999,
};

interface Props extends ModalProps {
  children: ReactElement;
  open: boolean;
  /** Extra styles merged into the modal content box (e.g. narrower width). */
  contentSx?: BoxProps["sx"];
}

const CModal = forwardRef<HTMLDivElement, Props>(
  ({ children, open, contentSx, ...other }, ref) => {
    const isDesktop = useMediaQuery();

    return (
      <Modal open={open} {...other}>
        <Box
          sx={{
            ...(isDesktop ? DesktopStyle : MobileStyle),
            ...((contentSx as object) || {}),
          }}
          ref={ref}
        >
          {children}
          <Box
            component="img"
            src={"/icons/close-icon.svg"}
            onClick={() => other.onClose && other.onClose({}, "backdropClick")}
            alt="Close"
            sx={{
              position: "absolute",
              right: "20px",
              top: "20px",
              "@media (min-width: 768.5px)": {
                right: "32px",
                top: "32px",
              },
              cursor: "pointer",
            }}
          />
        </Box>
      </Modal>
    );
  }
);

export default CModal;
